export default {
  translation: {
    appName: "Vivre en Santé",
    appSubtitle: "Staff Portal",
    nav: {
      dashboard: "Dashboard", staff: "Staff", schedule: "Schedule",
      leaves: "Leaves", timeclock: "Time Clock", badges: "Badges", patients: "Usagers",
      activities: "Activities",
      activityCatalog: "Activity Catalog",
      transport: "Transport", incidents: "Incidents", centers: "Centers",
      permissions: "Permissions",
      privacyIncidents: "Privacy",
      reports: "Reports", settings: "Settings", logout: "Logout",
    },
    auth: {
      login: "Sign In", logout: "Sign Out", email: "Email", password: "Password",
      forgotPassword: "Forgot password?", changePassword: "Change Password",
      currentPassword: "Current Password", newPassword: "New Password",
      confirmPassword: "Confirm Password",
      mustChangePassword: "You must change your password to continue.",
      welcomeBack: "Welcome back", loginTitle: "Sign in to your portal",
    },
    legal: {
      footerPrivacy: "Privacy",
      footerAccessibility: "Accessibility",
      title: "Privacy and personal information",
      subtitle: "Information published by {{organization}} regarding the protection of personal information.",
      backToLogin: "Back to sign in",
      responsibleHeading: "Person in charge of personal information protection",
      policyHeading: "Privacy practices",
      policyIntro: "{{organization}} collects and uses only the information required to manage the portal, access, services, and authorized clinical or operational follow-up.",
      contactHeading: "Exercise your rights or ask a question",
      contactText: "For any access request, correction request, withdrawal of consent where applicable, or to report a privacy incident, contact the responsible person below.",
      lastUpdated: "Last updated: {{date}}",
      policyItems: {
        collection: "Information is collected for authentication, record management, scheduling, time tracking, and authorized follow-up.",
        use: "Access to information is limited based on role and work-related need.",
        access: "Information may be disclosed to authorized service providers or partners only when necessary to operate the service and under appropriate safeguards.",
        security: "Administrative, technical, and physical safeguards are applied to protect personal information.",
        retention: "Information is retained only for as long as necessary for the intended purposes and applicable legal obligations.",
        rights: "Individuals may request access to or correction of their personal information in accordance with applicable law."
      }
    },
    accessibility: {
      title: "Accessibility",
      subtitle: "Accessibility statement for the staff portal.",
      skipToContent: "Skip to main content",
      primaryNav: "Primary navigation",
      sidebarNav: "Sidebar",
      openMenu: "Open main menu",
      closeMenu: "Close main menu",
      languageSelector: "Language selector",
      commitment: "We are committed to improving the accessibility of the staff portal for people with disabilities and users of assistive technologies.",
      measuresTitle: "Current measures",
      measure1: "Explicit association between labels and form fields in public flows.",
      measure2: "Automatic update of the document language based on the selected display language.",
      measure3: "Publication of a contact point to report an accessibility barrier.",
      feedbackTitle: "Report a barrier",
      feedbackText: "If you encounter an accessibility, navigation, or comprehension issue on this portal, contact us and we will review it."
    },
    dashboard: {
      title: "Dashboard", welcome: "Hello", overview: "System Overview",
      activeStaff: "Active Staff", activeManagers: "Active Managers", pendingLeaves: "Pending Leaves",
      todayShifts: "Today's Shifts", totalPatients: "Total Usagers",
      quickActions: "Quick Actions", addStaff: "Add Staff",
      addCenter: "Add Center", viewLeaves: "View Leaves", viewSwaps: "View Swaps",
      recentActivity: "Recent Activity",
    },
    staff: {
      title: "Staff Management", addStaff: "Add Employee", editStaff: "Edit Employee",
      firstName: "First Name", lastName: "Last Name", email: "Email", phone: "Phone",
      role: "Role", center: "Center", employeeNumber: "Employee #", status: "Status",
      active: "Active", inactive: "Inactive", lastLogin: "Last Login",
      searchPlaceholder: "Search staff...", noStaff: "No staff found",
    },
    roles: { admin: "Administrator", manager: "Manager", staff: "Personnel", usager: "User", patient: "User" },
    shifts: {
      title: "Schedules", addShift: "Add Shift", editShift: "Edit Shift",
      startTime: "Start Time", endTime: "End Time", assignTo: "Assign To",
      scheduled: "Scheduled", completed: "Completed", cancelled: "Cancelled", swapped: "Swapped",
      noShifts: "No shifts scheduled",
    },
    leaves: {
      title: "Leave Management", requestLeave: "Request Leave",
      startDate: "Start Date", endDate: "End Date", type: "Leave Type",
      reason: "Reason", status: "Status", pending: "Pending",
      approved: "Approved", rejected: "Rejected", approve: "Approve", reject: "Reject",
      reviewNote: "Review Note",
      leaveTypes: { vacation: "Vacation", sick: "Sick Leave", personal: "Personal", unpaid: "Unpaid", other: "Other" },
      noLeaves: "No leave requests",
    },
    timeclock: {
      title: "Time Clock", clockIn: "Clock In", clockOut: "Clock Out",
      clockedIn: "Clocked In — on duty", notClockedIn: "Not clocked in",
      since: "Since", hoursWorked: "Hours Worked", history: "History",
      date: "Date", entry: "Entry", exit: "Exit", duration: "Duration", source: "Source",
    },
    badgeScan: {
      badgeKiosk: "Badge Kiosk",
      operatorLogin: "Dedicated operator login",
      username: "Username",
      password: "Password",
      openKiosk: "Open kiosk",
      connecting: "Connecting...",
      invalidCredentials: "Invalid kiosk credentials",
      invalidSession: "Invalid kiosk session",
      defaultCenter: "Center",
      welcomeScan: "Welcome to {{center}}. Please scan your badge",
      autoReading: "Automatic reading active",
      noAuth: "No active badge authentication",
      noAuthHelp: "Log in kiosk or provide an API key in test mode",
      validating: "Validating...",
      welcome: "Welcome",
      thanks: "Thank you, see you next time",
      entrySaved: "Entry recorded",
      exitSaved: "Exit recorded",
      rejectedScan: "Scan rejected",
      checkBadge: "Check badge/assignment/center access",
      serialError: "Serial error",
      hidError: "USB HID error",
      nfcError: "Web NFC error",
      nfcNoUid: "UID not available via Web NFC",
      nfcReadFailed: "NFC read failed on this tag",
      nfcSecureContextRequired: "Web NFC requires HTTPS",
      statusScan: "Scan status",
      waitingBadge: "Waiting for badge...",
      configMode: "Configuration / test mode",
      apiKey: "Badge API key",
      centerName: "Center name",
      logoUrl: "Logo (URL)",
      deviceId: "Device ID",
      sourceSystem: "Source System",
      serialBaud: "Serial baud rate",
      connectSerial: "Connect Serial USB",
      disconnectSerial: "Disconnect Serial",
      connectHid: "Connect USB HID",
      disconnectHid: "Disconnect USB HID",
      connectWebNfc: "Enable Web NFC",
      disconnectWebNfc: "Disable Web NFC",
      connected: "Connected",
      disconnected: "Disconnected",
      notSupported: "Not supported",
      serial: "Serial",
      hid: "USB HID",
      webNfc: "Web NFC",
      keyboardScanner: "Keyboard scanner: active (focused input)",
      wedgePlaceholder: "Keyboard/wedge scanner: badge then Enter",
      validateScan: "Validate scan",
      presentBadge: "Present your badge",
      autoInOut: "Entry / Exit automatically detected by backend",
      localKiosk: "Local badge kiosk",
      socketLocal: "Local bridge",
      socketUrl: "Bridge URL",
      hideConfig: "Hide config",
      showConfig: "Config / test mode",
      lock: "Lock",
      timezone: "Timezone ET (America/Toronto)",
      unknownUser: "User",
      eventLabel: "Event",
    },
    patients: {
      title: "Usager Records", addPatient: "Add Usager", editRecord: "Edit Record",
      dateOfBirth: "Date of Birth", gender: "Gender", healthCard: "Health Card #",
      bloodType: "Blood Type", allergies: "Allergies", medications: "Current Medications",
      conditions: "Medical Conditions", insurance: "Insurance", insuranceNumber: "Insurance #",
      emergencyContact: "Emergency Contact", emergencyPhone: "Emergency Phone",
      admissionDate: "Admission Date", notes: "Notes", noPatients: "No usagers found",
    },
    centers: {
      title: "Center Management", addCenter: "Add Center", editCenter: "Edit Center",
      name: "Center Name", address: "Address", phone: "Phone", email: "Email",
      staffCount: "Staff Count", noCenters: "No centers found",
    },
    reports: {
      title: "Reports", timesheets: "Clocking Report", workHours: "Work Hours",
      payroll: "Payroll", coverage: "Center Coverage", generate: "Generate",
      export: "Export CSV", startDate: "Start Date", endDate: "End Date",
      totalHours: "Total Hours", employee: "Employee",
      kpi: {
        title: "Usager KPIs",
        socializationRate: "Socialization rate",
        autonomyProgressRate: "Autonomy progress",
        familySatisfactionRate: "Family caregiver satisfaction",
        fallsCount: "Falls count",
        activityParticipationRate: "Activity participation",
        activityFrequencyPerPatient: "Activity frequency / usager",
        hospitalizationReductionRate: "Hospitalization reduction",
        careFollowupRate: "Care follow-up",
        mealSatisfactionRate: "Meal satisfaction",
        presenceRate: "Presence rate",
        patientTableTitle: "KPI by usager",
      },
    },
    common: {
      save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", view: "View",
      close: "Close", expand: "Expand", reduce: "Reduce", expandWindow: "Expand window", reduceWindow: "Reduce window", confirm: "Confirm", search: "Search", filter: "Filter",
      all: "All", yes: "Yes", no: "No", loading: "Loading...", error: "An error occurred",
      success: "Success", noData: "No data", required: "Required field",
      actions: "Actions", createdAt: "Created", updatedAt: "Updated",
      page: "Page", of: "of", perPage: "per page",
    },
  },
};
